<template>
  <div>
    <v-list two-line>
      <v-subheader> Logs Partilhados </v-subheader>
      <v-divider></v-divider>
      <v-list-tile
        @click=""
        v-for="(notification, key) in displayableNotifications"
        :key="key"
      >
        <v-list-tile-content @click="editLog(notification)">
          <v-list-tile-title
            >{{ notification.header }} -
            <small class="grey--text" v-text="notification.createdAt"></small
          ></v-list-tile-title>
          <v-list-tile-sub-title>
            &mdash; '<span v-text="notification.text"></span
          ></v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn @click.prevent="deleteItem(notification)" small icon ripple>
            <v-icon small color="grey lighten-1">delete</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-dialog
      v-model="showDisplayDialog"
      :persistent="true"
      :fullscreen="isMobile"
      :max-width="expandDialog ? '80%' : 600"
      lazy
    >
      <LogForm
        :contentLoading="loading"
        :internship.sync="internship"
        :internshipList="internshipList"
        :log-to-edit="logToDisplay"
        :key="(logToDisplay || {}).id"
        :close="closeDisplayLogForm"
        :forApprovalDashboard="true"
        :internshipMandatory="internshipMandatory"
        :afterSubmit="deleteNotification"
        :afterReject="deleteNotification"
        :expandDialog.sync="expandDialog"
        :style="isMobile ? 'min-height: 100vh;' : ''"
      />
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import LogForm from '../Logbook/components/LogForm.vue'
import { InternshipsSpecialty } from '../../models/Content'
import moment from 'moment'
export default {
  components: {
    LogForm
  },
  props: {
    count: { type: Number }
  },
  data() {
    return {
      loading: false,
      selectedNotification: null,
      internship: '',
      internshipMandatory: false,
      internshipList: [],
      showDisplayDialog: false,
      logToDisplay: null,
      expandDialog: false
    }
  },
  async created() {
    this.loading = true
    await this.getNotifications()
    await this.getInternships()
    this.loading = false
  },
  computed: {
    ...mapGetters(['notifications', 'internships']),

    fetchingLogs() {
      return this.notifications.length >= 1
    },

    displayableNotifications() {
      const notifications = this.notifications.map(row => {
        const date = moment(
          row.createdAt.seconds ? row.createdAt.toDate() : row.createdAt
        )
        return {
          ...row,
          createdAt: date.format('DD/MM/YYYY')
        }
      })
      this.$emit('update:count', notifications.length)
      return notifications
    },

    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    }
  },

  methods: {
    ...mapActions([
      'getNotifications',
      'deleteNotifications',
      'showSuccessSnackbar',
      'showErrorSnackbar',
      'getInternships',
      'getUser'
    ]),
    deleteNotification() {
      this.deleteItem(this.selectedNotification)
    },

    internShipsFromAnotherSpecialty() {
      const internships = InternshipsSpecialty.query()
        .where(l => l.specialities.includes(this.$store.getters.specialty))
        .get()
      return internships.length >= 1 ? internships.map(i => i.id) : []
    },

    editLog(item) {
      const notification = this.notifications.find(l => l.id === item.id)
      if (this.userValidation(notification) === true) {
        this.logToDisplay = notification.metadata.log
        this.showDisplayDialog = true
        this.selectedNotification = notification
      }
    },
    userValidation(notification) {
      // user Validations
      let SpecialInternships = this.internShipsFromAnotherSpecialty()
      if (
        notification.metadata.sharedUserSpecialty ===
        this.$store.getters.specialty
      ) {
        // user has the same specialty

        if (notification.metadata.sharedUserinternship) {
          // is internship populated

          if (
            SpecialInternships.find(
              i => i === notification.metadata.sharedUserinternship
            )
          ) {
            // is an internship of another specialty
            this.internshipList = [
              ...new Set(
                this.internships.filter(
                  i =>
                    i.internship === notification.metadata.sharedUserinternship
                )
              )
            ]
            if (this.internshipList.length === 0) {
              //  to have access to this log is mandatory to have internship
              const text =
                'Necessário a criação de um estágio:' +
                '' +
                notification.metadata.sharedUserinternship
              this.showErrorSnackbar(text)
              return false
            } else {
              this.internship = this.internshipList[0].internship
              this.internshipMandatory = true
            }
          } else {
            this.internshipList = [
              ...new Set(
                this.internships.filter(
                  i =>
                    i.internship && !SpecialInternships.includes(i.internship)
                )
              )
            ]
          }
        } else {
          this.internshipList = [
            ...new Set(
              this.internships.filter(
                i => i.internship && !SpecialInternships.includes(i.internship)
              )
            )
          ]
        }
      } else if (
        this.$store.getters.specialty ===
        notification.metadata.sharedUserinternship
      ) {
        this.internshipList = [
          ...new Set(
            this.internships.filter(
              i => i.internship && !SpecialInternships.includes(i.internship)
            )
          )
        ]
      } else if (
        SpecialInternships.find(
          i => i === notification.metadata.sharedUserSpecialty
        )
      ) {
        this.internshipList = [
          ...new Set(
            this.internships.filter(
              i => i.internship === notification.metadata.sharedUserSpecialty
            )
          )
        ]
        if (this.internshipList.length === 0) {
          //  to have access to this log is mandatory to have internship
          const text =
            'Necessário a criação de um estágio:' +
            '' +
            notification.metadata.sharedUserSpecialty
          this.showErrorSnackbar(text)
          return false
        } else {
          this.internshipMandatory = true
          this.internship = this.internshipList[0].internship
        }
      }
      return true
    },
    deleteItem(item) {
      const notification = this.notifications.find(l => l.id === item.id)
      this.deleteNotifications([notification]).catch(err =>
        this.showErrorSnackbar(err.message || 'Erro ao apagar o log')
      )
    },
    closeDisplayLogForm() {
      this.internship = ''
      this.internshipMandatory = false
      this.internshipList = []
      this.showDisplayDialog = false
      this.logToDisplay = null
    }
  }
}
</script>
<style>
td span {
  white-space: pre-line;
}
</style>
